import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
// import * as Chartist from 'chartist';
import { FoodHistoryData } from '../../histories/food-history/food-history.component';
import { BackOffServiceService } from '../../services/back-off-service.service';
import { environment } from 'src/environments/environment';
import { LogsData } from '../../model/LogsData';
import * as Parse from 'parse';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Chart } from 'chart.js';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../../alert-component';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { QuizData } from '../../questionaire/QuizData';

declare var $: any;
@Component({
  selector: 'app-food-trend',
  templateUrl: './food-trend.component.html',
  styleUrls: ['./food-trend.component.css']
})
export class FoodTrendComponent implements OnInit {
  coachFeedbackForm : FormGroup;
  
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  data: LogsData[];
  canvas: any;
  ctx: any;
  @ViewChild('mychart') mychart;

  buttonColor = ["primary", "default", "primary", "primary", "primary", "default", "primary"];
  buttonMessage = ["unlogged", "", "unlogged", "unlogged", "unlogged", "", "unlogged"];
  Food2Lose = 0;
  Food2Update = 0;
  foodGoal = 0;
  foodStack = [0, 0, 0, 0, 0, 0, 0];
  foodStack2 = [0, 0, 0, 0, 0, 0, 0, 0];
  myChart: Chart;
  Foodlabels = Last7Days().reverse();
  Foodlabels2 = Last8Weeks().reverse();
  limit_line = [0, 0, 0, 0, 0, 0, 0];
  limit_line2 = [0, 0, 0, 0, 0, 0, 0];
  prevM = "";
  index = -1;




  topLabel = "past week of food data";

  weekColor = true;
  monthColor = false;

  constructor(
    private _bkoffService: BackOffServiceService, private breakpointObserver: BreakpointObserver,
    private router: Router,
    private cookie: CookieService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal,
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }
  ngOnInit() {
    this.coachFeedbackForm = this.formBuilder.group({
      weekly_log: ['', Validators.required],
      positives_negatives: ['', Validators.required],
      specific_suggestion: ['', Validators.required],
    })
  }

  get fmBuilder() { return this.coachFeedbackForm.controls; }
  getFormControl(name:any) {
    return this.coachFeedbackForm.get(name);
  }
  reset(){
    this.coachFeedbackForm.reset({PersonalData: new QuizData()});
  }
  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.coachFeedbackForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.coachFeedbackForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  submitFeedbackForm(){
    const result: QuizData = Object.assign({}, this.coachFeedbackForm.value); 
    if (this.coachFeedbackForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      return;
    }

    const signUpData = this.coachFeedbackForm;
     console.log(String(signUpData.get(['weekly_log']).value));
     console.log(String(signUpData.get(['positives_negatives']).value));
     console.log(String(signUpData.get(['specific_suggestion']).value));
     
      var userInfo = new QuizData()
      userInfo.weekly_log = String(signUpData.get(['weekly_log']).value)
      userInfo.positives_negatives = String(signUpData.get(['positives_negatives']).value)
      userInfo.specific_suggestion = String(signUpData.get(['specific_suggestion']).value)
      this._bkoffService.setCoachFeedbackDataFood(userInfo);
      const modalRef = this.modalService.open(NgbdModalContent);
      this.closeFeedbackForm();
      signUpData.setValue({['positives_negatives']: null, ['specific_suggestion']: null, ['weekly_log']: null});
      modalRef.componentInstance.name = "Patient's food feedback saved";
      modalRef.componentInstance.title = 'Success';
  };

  ngAfterViewInit() {
    this.canvas = this.mychart.nativeElement;
    this.ctx = this.canvas.getContext('2d');
    const patientID = this.cookie.get("patientID");
    var checkCoach = this.cookie.get('coach');

    if (checkCoach === 'true'){
      this._bkoffService.getFoodCaloriesGoalCoach().then((res) => {
        console.log("res is " + res);
        this.foodGoal = res;
  
        console.log("label 1=" + this.Foodlabels[0]);
        let FOOD_DATA: FoodHistoryData[] = [];
        let weightBottom = [0, 0, 0, 0, 0, 0, 0];
        let viewedDates = [];
        const today = new Date().getTime();
        console.log("today: " + today);
        let indexDay = today;
        let index = this.foodStack.length - 1;
        this._bkoffService.getFoodHistoryCoach().then((res) => {
          this.data = res;
          this.data.forEach(element => {
            console.log(element.calories);
            let d = this.getDay(element.foodDate);
            let m = this.getMonth(element.foodDate);
            let y = this.getYear(element.foodDate);
            console.log("month: " + m);
            let day = new Date(m + " " + d + ", " + y + " 00:00:00").getTime();
  
            viewedDates.push(this.getDay(element.foodDate));
            let index = this.foodStack.length - 1;
            if (!(day < today - 604800000)) {
              const diff = Math.floor((today - day) / 86400000);
              if (index >= 0) {
                index -= diff;
                if (element.calories !== undefined) {
                  this.foodStack[index] += Number(element.calories);
                }
              }
            }
            console.log("foodstak " + this.foodStack);
            //weekly
            let index2 = this.foodStack2.length - 1;
            if (!(day < today - 5184000000)) {
              const diff = Math.floor((today - day) / 604800000);
              console.log("diff: " + diff);
              if (index2 >= 0) {
                index2 -= diff;
                if (element.calories !== undefined) {
                  this.foodStack2[index2] += Number(element.calories);
                }
              }
            }
          });
  
  
          this.Food2Lose = this.foodStack[this.foodStack.length - 1];
          this.Food2Update = Math.max(0, this.foodGoal - this.Food2Lose);
  
          let axisMin = 0;
          if (axisMin < 0) {
            axisMin = 0;
          }
  
          for (let i = 0; i < this.foodStack.length; i++) {
            if (this.foodStack[i] !== 0) {
              this.foodStack[i] -= axisMin;
            }
          }
          for (let i = 0; i < this.foodStack2.length; i++) {
            if (this.foodStack2[i] !== 0) {
              this.foodStack2[i] -= axisMin;
            }
          }
  
          for (let i = 0; i < this.Foodlabels.length; i++) {
            this.limit_line[i] = this.foodGoal - axisMin;
          }
          for (let i = 0; i < this.Foodlabels2.length; i++) {
            this.limit_line2[i] = this.foodGoal - axisMin;
          }
  
          this.myChart = new Chart(this.ctx, {
            type: 'bar',
            data: {
              labels: this.Foodlabels,
              datasets: [{
                label: "goal",
                type: "line",
                borderColor: "rgb(255, 134, 78)",
                backgroundColor: "rgb(255, 134, 78)",
                data: this.limit_line,
                fill: false,
                borderWidth: 4,
              },
              {
                label: "food-line",
                type: "line",
                borderColor: "rgba(52, 152, 219, 0.6)",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                data: [],
                fill: false,
                borderWidth: 4,
              },
              {
                label: "food-bar",
                type: "bar",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                backgroundColorHover: "#3e95cd",
                data: this.foodStack
              }
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
  
                    if (label) {
                      label += ': ';
                    }
                    label += tooltipItem.yLabel + axisMin;
                    return label;
                  }
                }
              },
              scales: {
                xAxes: [{
                  stacked: false,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    suggestedMin: axisMin,
                    callback: function (value, index, values) {
                      return axisMin + value;
                    }
                  }
                }]
              },
              legend: { display: true }
            }
          });
        });
      });
    }else{
      this._bkoffService.getFoodCaloriesGoal().then((res) => {
        console.log("res is " + res);
        this.foodGoal = res;
  
        console.log("label 1=" + this.Foodlabels[0]);
        let FOOD_DATA: FoodHistoryData[] = [];
        let weightBottom = [0, 0, 0, 0, 0, 0, 0];
        let viewedDates = [];
        const today = new Date().getTime();
        console.log("today: " + today);
        let indexDay = today;
        let index = this.foodStack.length - 1;
        this._bkoffService.getFoodHistory().then((res) => {
          this.data = res;
          this.data.forEach(element => {
            console.log(element.calories);
            let d = this.getDay(element.foodDate);
            let m = this.getMonth(element.foodDate);
            let y = this.getYear(element.foodDate);
            console.log("month: " + m);
            let day = new Date(m + " " + d + ", " + y + " 00:00:00").getTime();
  
            viewedDates.push(this.getDay(element.foodDate));
            let index = this.foodStack.length - 1;
            if (!(day < today - 604800000)) {
              const diff = Math.floor((today - day) / 86400000);
              if (index >= 0) {
                index -= diff;
                if (element.calories !== undefined) {
                  this.foodStack[index] += Number(element.calories);
                }
              }
            }
            console.log("foodstak " + this.foodStack);
            //weekly
            let index2 = this.foodStack2.length - 1;
            if (!(day < today - 5184000000)) {
              const diff = Math.floor((today - day) / 604800000);
              console.log("diff: " + diff);
              if (index2 >= 0) {
                index2 -= diff;
                if (element.calories !== undefined) {
                  this.foodStack2[index2] += Number(element.calories);
                }
              }
            }
          });
  
  
          this.Food2Lose = this.foodStack[this.foodStack.length - 1];
          this.Food2Update = Math.max(0, this.foodGoal - this.Food2Lose);
  
          let axisMin = 0;
          if (axisMin < 0) {
            axisMin = 0;
          }
  
          for (let i = 0; i < this.foodStack.length; i++) {
            if (this.foodStack[i] !== 0) {
              this.foodStack[i] -= axisMin;
            }
          }
          for (let i = 0; i < this.foodStack2.length; i++) {
            if (this.foodStack2[i] !== 0) {
              this.foodStack2[i] -= axisMin;
            }
          }
  
          for (let i = 0; i < this.Foodlabels.length; i++) {
            this.limit_line[i] = this.foodGoal - axisMin;
          }
          for (let i = 0; i < this.Foodlabels2.length; i++) {
            this.limit_line2[i] = this.foodGoal - axisMin;
          }
  
          this.myChart = new Chart(this.ctx, {
            type: 'bar',
            data: {
              labels: this.Foodlabels,
              datasets: [{
                label: "goal",
                type: "line",
                borderColor: "rgb(255, 134, 78)",
                backgroundColor: "rgb(255, 134, 78)",
                data: this.limit_line,
                fill: false,
                borderWidth: 4,
              },
              {
                label: "food-line",
                type: "line",
                borderColor: "rgba(52, 152, 219, 0.6)",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                data: [],
                fill: false,
                borderWidth: 4,
              },
              {
                label: "food-bar",
                type: "bar",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                backgroundColorHover: "#3e95cd",
                data: this.foodStack
              }
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
  
                    if (label) {
                      label += ': ';
                    }
                    label += tooltipItem.yLabel + axisMin;
                    return label;
                  }
                }
              },
              scales: {
                xAxes: [{
                  stacked: false,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    suggestedMin: axisMin,
                    callback: function (value, index, values) {
                      return axisMin + value;
                    }
                  }
                }]
              },
              legend: { display: true }
            }
          });
        });
      });
    }


  }
    

  getDay(date: string): string {
    let res = date.split(" ");
    let day = res[1];
    res = day.split(",");
    day = res[0];
    return day;
  }

  getMonth(date: string): string {
    let res = date.split(" ");
    return res[0];
  }

  getYear(date: string): string {
    let res = date.split(" ");
    return res[3];
  }

  getToday(): Number {
    let d = new Date();
    let day = Number(d.getDate());
    return day;
  }

  toLogs() {
    this.router.navigateByUrl('/logs');
  }

  toggleWeek() {
    this.weekColor = true;
    this.monthColor = false;
    this.topLabel = "past week of food data";
    this.myChart.data.labels = this.Foodlabels;
    this.myChart.data.datasets[2].data = this.foodStack;
    this.myChart.data.datasets[1].data = [];
    this.myChart.data.datasets[0].data = this.limit_line;
    this.myChart.update();
  }

  toggleMonth() {
    this.weekColor = false;
    this.monthColor = true;
    this.topLabel = "past 2 months of food data";
    this.myChart.data.labels = this.Foodlabels2;
    this.myChart.data.datasets[2].data = this.foodStack2;
    this.myChart.data.datasets[1].data = [];
    this.myChart.data.datasets[0].data = false;
    this.myChart.update();

  }

  checkCoach(): Boolean {
    console.log("checking coach");
    if (this.cookie.get('coach') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  openFeedbackForm() {
    document.getElementById("feedbackForm").style.display = "block";
  }
  
  closeFeedbackForm() {
    document.getElementById("feedbackForm").style.display = "none";
  }

}


function formatDate(date) {

  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  let yyyy = date.getFullYear();
  if (dd < 10) { dd = '0' + dd; }
  if (mm < 10) { mm = '0' + mm; }
  date = mm.toString() + '/' + dd.toString();
  return date;
}

function Last7Days() {
  let result = [];
  for (let i = 0; i < 7; i++) {
    let d = new Date();
    d.setDate(d.getDate() - i);
    result.push(formatDate(d));
  }

  return (result);
}

function Last8Weeks() {
  let result = [];
  for (let i = 0; i < 8; i++) {
    let d = new Date();
    d.setDate(d.getDate() - i * 7);
    result.push(formatDate(d));
  }

  return (result);
}

function minWeight(weightArray) {
  let min = 100000;
  for (let i = 0; i < weightArray.length; i++) {
    if (weightArray[i] < min && weightArray[i] !== 0) {
      min = weightArray[i];
    }
  }
  return min;
}